// extracted by mini-css-extract-plugin
export default {"list":"PaymentTypesPicker_list__yUUjd","slide":"PaymentTypesPicker_slide__rIXbN"};